import { PartialTranslation } from '../translations';

export const he: PartialTranslation = {
  newChat: 'צ\'אט חדש',
  search: 'חיפוש',
  user: 'משתמש',
  settings: 'הגדרות',
  language: 'שפה',
  getHelp: 'קבל עזרה',
  viewAllPlans: 'הצג את כל התוכניות',
  learnMore: 'למד עוד',
  logOut: 'התנתק',
  chooseLanguage: 'בחר שפה',
  chooseYourPreferredLanguage: 'בחר את השפה המועדפת עליך',
  searchLanguages: 'חפש שפות...',
  autoDetect: 'זיהוי אוטומטי',
  noLanguagesFound: 'לא נמצאו שפות',
  askAnything: 'שאל כל דבר',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'אישי',
  freePlan: 'תוכנית חינמית',
  current: 'נוכחי',
  close: 'סגור',
  archive: 'ארכיון',
  delete: 'מחק',
  confirmDelete: 'האם אתה בטוח שברצונך למחוק את הצ\'אט הזה?',
  confirmArchive: 'האם אתה בטוח שברצונך לארכב את הצ\'אט הזה?',
  deleteCannotUndo: 'לא ניתן לבטל פעולה זו.',
  archiveCanFind: 'תוכל למצוא אותו ברשימת הארכיון לאחר הארכוב.',
  
  // 资源面板
  resources: 'משאבים',
  addResource: 'הוסף משאב',
  deleteResource: 'מחק משאב',
  noMatchingResourcesFound: 'לא נמצאו משאבים תואמים',
  noResourcesAvailable: 'אין משאבים זמינים',
  hideResources: 'הסתר משאבים',
  showResources: 'הצג משאבים',
  
  // 聊天输入框
  typeMessage: 'הקלד הודעה...',
  thinkingOptions: 'אפשרויות חשיבה',
  deleteFile: 'מחק קובץ',
  clearSelection: 'נקה בחירה',
  addAttachment: 'הוסף קובץ מצורף',
  sendMessage: 'שלח הודעה',
  
  // 思考模式选项
  deepInsight: 'תובנה עמוקה · ניתוח שטחי',
  deepInsightDesc: 'הבנה מהירה של נקודות מפתח',
  deepExploration: 'חקירה עמוקה · ניתוח מקיף',
  deepExplorationDesc: 'מחקר עמוק רב-ממדי',
  deepDeconstruction: 'פירוק עמוק · טיעון שיטתי',
  deepDeconstructionDesc: 'ניתוח מתקדם שכבה אחר שכבה',
  
  // 写作模式选项
  contractReview: 'סקירת חוזה · זיהוי סיכונים',
  contractReviewDesc: 'ניתוח סעיפים ובדיקת התאמה',
  textPolish: 'ליטוש טקסט · ביטוי מקצועי',
  textPolishDesc: 'אופטימיזציה לשונית והתאמה מבנית',
  legalDocuments: 'מסמכים משפטיים · טיוטה סטנדרטית',
  legalDocumentsDesc: 'כתיבה מקצועית של מסמכים משפטיים',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'התחברות',
  register: 'הרשמה',
  welcomeBack: 'ברוכים הבאים ל-LawHelper',
  loginSubtitle: 'העוזר שלך למחקר משפטי בינה מלאכותית',
  continueWithGoogle: 'המשך עם Google',
  continueWithMicrosoft: 'המשך עם Microsoft',
  continueWithWeChat: 'המשך עם WeChat',
  orContinueWith: 'או המשך עם',
  emailTab: 'אימייל',
  phoneTab: 'טלפון',
  emailPlaceholder: 'הזן את האימייל שלך',
  phonePlaceholder: 'הזן מספר טלפון',
  codePlaceholder: 'הזן קוד בן 6 ספרות',
  sending: 'שולח...',
  verifying: 'מאמת...',
  verify: 'אמת',
  sendMagicLink: 'שלח קישור קסם',
  getVerificationCode: 'קבל קוד',
  resendCode: 'שלח קוד מחדש',
  resendIn: 'שלח שוב בעוד',
  magicLinkSent: 'קישור קסם נשלח לאימייל שלך',
  magicLinkHint: 'נשלח קישור מאובטח לאימייל שלך',
  otpSent: 'קוד אימות נשלח',
  agreeToTerms: 'בהמשך, אתה מסכים ל',
  privacyPolicy: 'מדיניות פרטיות',
  termsOfService: 'תנאי שירות',
  and: 'ו',
  privacyTitle: 'הפרטיות שלך חשובה',
  privacyIntro: 'אנו משתמשים בעוגיות וטכנולוגיות דומות כדי לספק לך את החוויה הטובה ביותר.',
  essentialCookies: 'עוגיות חיוניות',
  essentialDesc: 'נדרשות לתפקוד האתר',
  analyticsCookies: 'עוגיות אנליטיות',
  analyticsDesc: 'עוזרות לנו לשפר את השירות',
  marketingCookies: 'עוגיות שיווקיות',
  marketingDesc: 'משמשות לתוכן מותאם אישית',
  acceptAll: 'קבל הכל',
  essentialOnly: 'חיוניות בלבד',
  customize: 'התאמה אישית',
  savePreferences: 'שמור העדפות',
  back: 'חזור',
  readPrivacyPolicy: 'קרא את מדיניות הפרטיות שלנו',
  cookiePolicy: 'מדיניות עוגיות',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'סקירת AI',
  aiDraft: 'טיוטת AI',
  smartAssistant: 'תבנית',

  // 知识库搜索
  enableKnowledgeSearch: 'הפעל חיפוש',
  knowledgeSearchDesc: 'AI מחפש במסמכים שלך',
  clickToDisable: 'בטל',
  clickToEnable: 'הפעל',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'סגור לוח משאבים',
  uploading: 'מעלה %{fileName}...',
  processing: 'מעבד %{fileName}...',
  uploadSuccess: '✓ %{fileName} הועלה',
  uploadError: '✗ העלאה נכשלה: %{error}',
  quickAnswer: 'תשובה מהירה',
  quickAnswerDesc: 'תשובה מהירה לשאלות פשוטות',
  cancelRequest: 'ביטול',
  library: 'ספרייה',
  filterAll: 'הכל',
  filterChat: 'צ׳אטים',
  filterReview: 'סקירה',
  filterDraft: 'טיוטה',
  filterTemplate: 'תבנית',
  filterForm: 'טופס',
  thinking: 'חושב...',
  thinkingProcess: 'תהליך חשיבה',
  analyzingLegalLogic: 'מנתח לוגיקה משפטית...',
  lawhelperThinking: 'Lawhelper חושב...',
  serviceError: 'שגיאת שירות',
  uploaded: 'הועלה',
  settingsGeneral: 'כללי',
  settingsNotifications: 'התראות',
  settingsAppearance: 'מראה',
  settingsProfile: 'פרופיל',
  settingsResponseNotifications: 'התראות תגובה',
  settingsResponseNotificationsDesc: 'התראה כאשר ה-AI מסיים לענות',
  settingsColorMode: 'מצב צבע',
  settingsLight: 'בהיר',
  settingsDark: 'כהה',
  settingsSystem: 'מערכת',
  about: 'אודות',
  reviewTitle: 'סקירת מסמך',
  exitReview: 'יציאה מסקירה',
  uploadPrompt: 'העלה PDF לסקירה',
  uploadButton: 'בחר קובץ',
  startChatConfig: 'הקלד "סקור מסמך זה"',
  reviewPlaceholder: 'הקלד הודעה...',
  analyzing: 'סוקר...',
  reviewComplete: 'הסקירה הושלמה',
  issuesFound: 'נמצאו %{count} בעיות',
  draftTitle: 'עריכת מסמך משפטי',
  draftPlaceholder: 'ערוך כאן או בקש מה-AI...',
  analyzingTemplate: 'מנתח תבנית %{name}...',
  templateAnalyzed: '✅ תבנית %{name} נותחה!',
  templateAnalysisPrompt: 'נתח סעיפים מרכזיים',
  parsingFailed: '⚠️ ניתוח הקובץ נכשל.',
  generating: 'יוצר...',
  generatedSuccess: '✅ המסמך נוצר!',
  drafterWelcome: 'ברוכים הבאים לעוזר מסמכים AI',
  drafterYouCan: 'ניתן:',
  drafterUploadTemplate: 'להעלות תבנית לניתוח AI',
  drafterDescribeNeeds: 'לתאר דרישות המסמך',
  drafterLetAiHelp: 'AI מסייע בעריכת חוזים, הסכמים ועוד',
  drafterExamples: 'דוגמאות:',
  drafterExampleRental: '"ערוך חוזה שכירות"',
  drafterExampleLabor: '"מלא חוזה עבודה"',
  drafterInputPlaceholder: 'תאר את צרכיך...',
  drafterThinking: 'חושב...',
  drafterHistoryTitle: 'היסטוריה',
  drafterNoHistory: 'אין היסטוריה',
  drafterNewChat: 'צ׳אט חדש',
  drafterHistory: 'היסטוריה',
  drafterRemoveAttachment: 'הסר קובץ מצורף',
  drafterLineHeight: 'גובה שורה',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'ייצוא ל-Word (.docx)',
  drafterExportPdf: 'ייצוא ל-PDF',
  drafterSave: 'שמור מסמך',
  drafterDownload: 'הורד מסמך',
  drafterUndo: 'בטל',
  drafterRedo: 'בצע שוב',
  drafterBold: 'מודגש',
  drafterItalic: 'נטוי',
  drafterStrike: 'קו חוצה',
  drafterUnderline: 'קו תחתון',
  drafterHighlight: 'הדגשה',
  drafterLink: 'הוסף קישור',
  drafterAlignLeft: 'יישור שמאלה',
  drafterAlignCenter: 'מרכז',
  drafterAlignRight: 'יישור ימינה',
  drafterAlignJustify: 'יישור מלא',
  drafterList: 'רשימה',
  drafterBulletList: 'תבליטים',
  drafterOrderedList: 'רשימה ממוספרת',
  drafterTaskList: 'רשימת משימות',
  drafterOpenResource: 'פתח משאבים',
  drafterStopGeneration: 'עצור יצירה',
  drafterAgentMode: 'מצב סוכן פעיל',
  drafterAgentModeOn: 'מצב סוכן פעיל',
  drafterAgentModeOff: 'מצב רגיל',
  drafterUploadAttachment: 'העלה קובץ מצורף',
  drafterExit: 'יציאה',
  drafterConfirm: 'אישור',
  drafterOpenLink: 'פתח קישור',
  drafterDeleteLink: 'מחק קישור',
  drafterQuote: 'ציטוט',
  workflowTitle: 'תהליך AI',
  workflowRunning: 'רץ...',
  workflowReady: 'מוכן',
  workflowCompleted: 'הושלם',
  workflowStartFailed: 'התחלת תהליך נכשלה',
  workflowExecutionFailed: 'ביצוע נכשל',
  workflowInterrupted: 'התהליך הופסק',
  workflowProcessing: 'מעבד...',
  workflowStepsCompleted: 'שלבים הושלמו',
  workflowStepsTotal: 'תהליך הושלם (%{count} שלבים)',
  acceptChanges: 'קבל שינויים',
  rejectChanges: 'דחה שינויים',
  changesAccepted: 'שינויים התקבלו',
  changesRejected: 'שינויים נדחו',
  stopWorkflow: 'עצור',
  restartWorkflow: 'הפעל מחדש',
  startDrafting: 'התחל עריכה',
  interrupt: 'עצור',
  documentSubject: 'נושא המסמך *',
  documentType: 'סוג מסמך',
  jurisdiction: 'סמכות שיפוט',
  specialRequirements: 'דרישות מיוחדות (אופציונלי)',
  clickStartDrafting: 'לחץ "התחל עריכה"',
  docTypeContract: 'חוזה',
  docTypeAgreement: 'הסכם',
  docTypeNotice: 'הודעה',
  docTypeLetter: 'מכתב',
  docTypePetition: 'עתירה',
  docTypeWill: 'צוואה',
  docTypePowerOfAttorney: 'ייפוי כוח',
  countryChina: 'סין',
  countryUSA: 'ארה"ב',
  countryGermany: 'גרמניה',
  countryJapan: 'יפן',
  countryFrance: 'צרפת',
  countryUK: 'בריטניה',
  citationVerified: 'מאומת',
  citationUnverified: 'לא מאומת',
  imageLoadFailed: 'טעינת תמונה נכשלה',
  smartDocTitle: 'עוזר מסמכים חכם',
  smartDocChatTitle: 'עוזר מסמכים AI',
  smartDocDropPrompt: 'שחרר קובץ PDF כאן',
  smartDocSelectFile: 'בחר קובץ',
  smartDocOr: 'או',
  smartDocWelcomeTitle: 'ברוכים הבאים לעוזר AI',
  smartDocWelcomeYouCan: 'ניתן:',
  smartDocUploadForAI: 'להעלות תבנית',
  smartDocDescribeDoc: 'לתאר דרישות',
  smartDocLetAIDraft: 'AI מסייע בחוזים',
  smartDocExamples: 'דוגמאות:',
  smartDocExampleRental: '"ערוך חוזה שכירות"',
  smartDocExampleLabor: '"מלא חוזה עבודה"',
  smartDocInputPlaceholder: 'תאר צרכים...',
  smartDocRemoveAttachment: 'הסר קובץ מצורף',
  smartDocOpenResources: 'פתח משאבים',
  smartDocExit: 'יציאה',
  reviewStartFailed: 'התחלת סקירה נכשלה',
  reviewFailed: 'הסקירה נכשלה',
  reviewFoundIssues: 'סקירה הושלמה, %{count} בעיות.',
  cannotReadStream: 'לא ניתן לקרוא זרם',
  parseEventFailed: 'ניתוח אירוע נכשל',
  errorPrefix: 'שגיאה',
  unknownError: 'שגיאה לא ידועה',
  file: 'קובץ',
  loading: 'טוען...',
  localFolders: 'תיקיות מקומיות',
  selectLocalFolder: 'בחר תיקייה מקומית',
  reselectFolder: 'החלף תיקייה',
  addToContext: 'הוסף לצ׳אט',
  saveFile: 'שמור',
  renameFile: 'שנה שם',
  fileSaved: 'הקובץ נשמר',
  fileRenamed: 'הקובץ שונה ל-%{name}',
  browserNotSupported: 'הדפדפן אינו תומך בגישה לתיקיות',
  noFolderSelected: 'בחר תיקייה מקומית',
  scanningFolder: 'סורק תיקייה...',
  selectFileToPreview: 'בחר קובץ לתצוגה מקדימה',
  aiAnalyze: 'ניתוח AI',
};
